module.exports = {
      id: "linkedin-usage",
      viewBox: "0 0 12 12",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#linkedin",
      toString: function () {
        return this.url;
      }
    }